<div class="message-form-wrapper">
  <div class="black-bg" (click)="onClose.emit(false)"></div>
  <div class="container nobottommargin message-form-container" >
    <div class="close-btn" (click)="onClose.emit(false)"></div>

    <h3> {{'MessageForm.ContactForm' | translate}} </h3>

    <div id="contact-form-result" data-notify-type="success"
         data-notify-msg="<i class=icon-ok-sign></i> Message Sent Successfully!"></div>

    <div class="nobottommargin" id="template-contactform" name="template-contactform">

      <div class="form-process"></div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Name) ? 'not-valid' : '')">
        <label for="template-contactform-name">{{'MessageForm.Name' | translate}}
          <small>*</small>
        </label>
        <input type="text" id="template-contactform-name" name="template-contactform-name" value=""
               class="sm-form-control required"
               (ngModelChange)="onChangeModel('Name', $event)"
               [ngModel]="requestModel.Name"/>
        <span> {{'MessageForm.NameError' | translate}} </span>
      </div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Email) ? 'not-valid' : '')">
        <label for="template-contactform-email">{{'MessageForm.Email' | translate}}
          <small>*</small>
        </label>
        <input type="email" id="template-contactform-email" name="template-contactform-email" value=""
               class="required email sm-form-control"
               (ngModelChange)="onChangeModel('Email', $event)"
               [ngModel]="requestModel.Email"/>
        <span> {{'MessageForm.EmailError' | translate}} </span>
      </div>

      <div class="col_one_third form-component col_last">
        <label for="template-contactform-phone">Phone</label>
        <input type="text" id="template-contactform-phone" name="template-contactform-phone" value=""
               class="sm-form-control"/>
      </div>

      <div class="clear"></div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Company) ? 'not-valid' : '')">
        <label for="template-contactform-subject">{{'MessageForm.Company' | translate}}
          <small>*</small>
        </label>
        <input type="text" id="template-contactform-subject" name="template-contactform-subject" value=""
               class="required sm-form-control"
               (ngModelChange)="onChangeModel('Company', $event)"
               [ngModel]="requestModel.Company"/>
        <span> {{'MessageForm.CompanyError' | translate}} </span>
      </div>

      <div [class]="'col_one_third form-component ' + ((notValid && !valid.Country) ? 'not-valid' : '')">
        <label for="template-contactform-subject2">{{'MessageForm.Country' | translate}}
          <small>*</small>
        </label>
        <input type="text" id="template-contactform-subject2" name="template-contactform-subject" value=""
               class="required sm-form-control"
               (ngModelChange)="onChangeModel('Country', $event)"
               [ngModel]="requestModel.Country"/>
        <span> {{'MessageForm.CountryError' | translate}} </span>
      </div>


      <div class="clear"></div>

      <div [class]="'col_full form-component ' + ((notValid && !valid.Message) ? 'not-valid' : '')">
        <label for="template-contactform-message">{{'MessageForm.Message' | translate}}
          <small>*</small>
        </label>
        <textarea class="required sm-form-control" id="template-contactform-message"
                  name="template-contactform-message" rows="6" cols="30"
                  (ngModelChange)="onChangeModel('Message', $event)"
                  [ngModel]="requestModel.Message">
              </textarea>
        <span> {{'MessageForm.MessageError' | translate}} </span>
      </div>

      <div class="col_full hidden">
        <input type="text" id="template-contactform-botcheck" name="template-contactform-botcheck" value=""
               class="sm-form-control"/>
      </div>

      <div [class]="'col_full form-component ' + ((notValid && !valid.Privacy) ? 'not-valid' : '')">
        <label class="checkbox">
          <input type="checkbox" id="template-contactform-privacy"
                 name="template-contactform-privacy" value=""
                 (ngModelChange)="onChangeModel('Privacy', $event)"
                 [ngModel]="requestModel.Privacy"/>
          <div class="checkbox__text">
            {{'MessageForm.Privacy.part1' | translate}}
            <a routerLink='/privacy-notice'>{{'MessageForm.Privacy.linkPart' | translate}}</a>
            {{'MessageForm.part2' | translate}}
          </div>
        </label>
        <span> {{'MessageForm.PrivacyError' | translate}} </span>
      </div>

      <div class="col_full topmargin">
        <button class="button button-3d nomargin" id="template-contactform-submit"
                name="template-contactform-submit"
                (click)="onSubmit()" value="submit">{{'MessageForm.SendMessage' | translate}}
        </button>
      </div>

    </div>

  </div>
</div>




